import Vue from 'vue'
import VueCarousel from 'vue-carousel'
import VueGtag from 'vue-gtag'
import VueMask from 'v-mask'
import VueTour from 'vue-tour'

import router from '@/routes/router'
import store from '@/stores'

import vuetify from '@/plugins/vuetify'
import 'vue-tour/dist/vue-tour.css'
import '@/styles/app.scss'

import App from '@/App.vue'

import { loadComponents } from '@/globals/components'
import { loadFilters } from '@/globals/filters'
import { loadMixins } from '@/globals/mixins'

loadComponents()
loadFilters()
loadMixins()

Vue.config.productionTip = false

store.commit('alertStore/CLEAR_ALERTS')

Vue.use(VueCarousel)
Vue.use(VueMask)
Vue.use(VueGtag, {
  config: {
    id: 'UA-164038543-1',
    send_page_view: false,
  },
  pageTrackerTemplate (to) {
    return {
      page_title: (to.meta || {}).title || 'LendingWell',
      page_path: to.path,
    }
  },
}, router)
Vue.use(VueTour)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
